// Логотип Resstro: оригинальное изображение из /src/images.
// Поддерживает вариант для тёмного фона через props.tone = 'light'.

import logoSrc from '@/images/Resstologo2.webp';

interface Props {
  className?: string;
  tone?: 'dark' | 'light';
}

export default function Logo({ className, tone = 'dark' }: Props) {
  return (
    <img
      src={logoSrc}
      alt="Resstro"
      className={[
        'block h-8 w-auto select-none sm:h-9',
        // Логотип оранжевый, на тёмном фоне делаем его белым через фильтры.
        tone === 'light' ? 'brightness-0 invert' : '',
        className ?? '',
      ]
        .filter(Boolean)
        .join(' ')}
      draggable={false}
    />
  );
}
